import {
  buildUtilityRoutePathMap,
  buildUtilitySeoRoutes,
} from '@saas-pages/shared/public/registry'
import { toSeoProps, withDefaultJsonLd, type SeoRouteConfig, type UmbrellaSeoRoutes } from '@saas-pages/shared/public/seo'
import branding from '../../branding.config'
import { calcdeckUtilityRegistry, type RouteKey as ToolRouteKey } from '../shared/utility-registry'

export type { ToolRouteKey }
export type AppRouteKey = 'index' | 'blog' | ToolRouteKey

const toolSeoRoutes = buildUtilitySeoRoutes(branding.domain, calcdeckUtilityRegistry)

const rawSeoRoutes: UmbrellaSeoRoutes<AppRouteKey> = {
  domain: branding.domain,
  routes: {
    index: {
      path: '/',
      title: 'Калькуляторы онлайн бесплатно - calcdeck.ru',
      description:
        'Бесплатные калькуляторы calcdeck.ru: проценты, дроби, пропорции, конвертер единиц и случайные числа. Локальные расчёты без регистрации.',
      changefreq: 'weekly',
      priority: 1,
    },
    blog: {
      path: '/blog',
      title: 'Блог о расчётах, формулах и числовых данных - calcdeck.ru',
      description:
        'Практические статьи calcdeck.ru о среднем, медиане, процентах, дробях, пропорциях и проверке результатов расчётов.',
      changefreq: 'weekly',
      priority: 0.8,
    },
    ...toolSeoRoutes.routes,
  } as Record<AppRouteKey, SeoRouteConfig>,
}

export const seoRoutes = withDefaultJsonLd(
  rawSeoRoutes,
  'Catalog page has no page-specific structured data.',
)

export const routePath: Record<ToolRouteKey, string> = buildUtilityRoutePathMap(
  calcdeckUtilityRegistry,
)

export function seoFor(key: AppRouteKey) {
  return toSeoProps(branding.domain, seoRoutes.routes[key])
}
